// extracted by mini-css-extract-plugin
var _1 = "OverviewViewingText-moduleOverviewViewingText__wM5YZ";
export { _1 as "OverviewViewingText" }
